import { UploadFileComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import ImageService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/ImageService";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { traceo } from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/Logging";
import { EnsolversOpsUser } from "../../models/EnsolversOpsUser";
import OpsUserService from "../../services/OpsUserService";
import UserService from "../../services/UserService";
import { ColorUtils } from "../../utils/ColorUtils";
import { useStyles } from "../Main/formStyles";
import { SpinnerWrapper } from "../SpinnerWrapper";

interface Props {
  userAvatarUpdate: EnsolversOpsUser | undefined;
  isLoading: boolean;
  setIsLoading(value: boolean): void;
  setUserAvatarUpdate(value: EnsolversOpsUser | undefined): void;
  setUser(value: EnsolversOpsUser | undefined): void;
}

export const UserAvatar = ({ userAvatarUpdate, isLoading, setIsLoading, setUserAvatarUpdate, setUser }: Props) => {
  const customStyles = useStyles();
  
  return (
    <>
      {userAvatarUpdate && (
        <GenericForm<File>
          headerStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}
          buttonStyles={{ marginRight: 20, color: 'white', backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom: 10 }}
          cancelButtonStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, border: `1px solid ${ColorUtils.ENSOLVERS_ORANGE_REBRANDING}`, marginBottom: 10 }}
          dialogStyles={customStyles.root}            
          dialog={true}
          open={true}
          title={"Edit avatar"}
          onSave={async (response: any) => {
            setIsLoading(true);
            if (response.file) {
              const fileName: string = `ensolvers-ops-avatar_${userAvatarUpdate!.externalId}`;
              try {
                const uploadImageResult = await ImageService.uploadImage(response.file, fileName, undefined);
                const avatarUrl = uploadImageResult.getContent().url;
                const updaterUser: EnsolversOpsUser = {
                  ...userAvatarUpdate,
                  avatarUrl,
                };
                await OpsUserService.update(updaterUser);
                await UserService.update(updaterUser);
                setUser(updaterUser);
                NotificationService.info("Avatar uploaded!");
              } catch (error) {
                traceo("Error uploading avatar", error, null);
                NotificationService.error("Error uploading avatar!");
              }
              setIsLoading(false);
            }
            setUserAvatarUpdate(undefined);
          }}
          onCancel={() => setUserAvatarUpdate(undefined)}
          renderContent={(register, errors, control) => (
            <SpinnerWrapper isLoading={isLoading}>
              <UploadFileComponent propertyName={"file"} label="" required={true} />
            </SpinnerWrapper>
          )}
        />
      )}
    </>
  );
};
